import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW5400Model } from './kymw5400.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW5800Component } from '../../kymw58/kymw5800/kymw5800.component';
import { KYMW0300Component } from '../../../commons/kymw03/kymw0300/kymw0300.component';

import { FlexGrid } from '@grapecity/wijmo.grid';
import { TreeView, FormatNodeEventArgs } from '@grapecity/wijmo.nav';
import { Menu } from '@grapecity/wijmo.input';

import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW0300InputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

import { GetCategoryCandidacyGoodsInfoService } from './api-services/get-category-candidacy-goods-info';
import { GetGoodsCategoryInfoService } from './api-services/get-goods-category-info.service';
import { Get54CategoryInfoService } from './api-services/get-54-category-info.service';
import { UpdateGoodsCategoryInfoService } from './api-services/update-goods-category-info.service';
import { KYMW5400commonModel } from './vo/kymw5400-common.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { DataGridUtil } from './../../../commons/kymw00/data-grid-util';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { Subject } from 'rxjs';
import { KYMW0300Model } from '../../../commons/kymw03/kymw0300/kymw0300.model';

/**
 * ECカテゴリ関連マスタ画面を管理するクラス
 *
 * @export KYMW5400Component
 * @class KYMW5400Component
 */
@Component({
  selector: 'app-kymw5400',
  templateUrl: 'kymw5400.component.html',
  styleUrls: ['kymw5400.component.scss'],
  providers: [
    GetCategoryCandidacyGoodsInfoService,
    GetGoodsCategoryInfoService,
    Get54CategoryInfoService,
    UpdateGoodsCategoryInfoService,
  ],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5400Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('tre_Category', { static: true }) tre_Category: TreeView;

  @ViewChild('dtg_TextInfoList', { static: true }) dtg_TextInfoList: FlexGrid;
  @ViewChild('dtg_GoodsList', { static: true }) dtg_GoodsList: FlexGrid;
  @ViewChild('dtg_CategoryGoodsList', { static: true }) dtg_CategoryGoodsList: FlexGrid;

  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;
  @ViewChild('btn_Search', { static: true }) btn_Search: ElementRef;
  @ViewChild('btn_Cancel', { static: true }) btn_Cancel: ElementRef;
  @ViewChild('btn_Update', { static: true }) btn_Update: ElementRef;

  // 対象から "商品マスタ" を外すためコメントアウト
  // @ViewChild('rdb_Category', { static: true }) rdb_Category: RadioLabelComponent;
  @ViewChild('rdb_PlanCategory', { static: true }) rdb_PlanCategory: RadioLabelComponent;
  @ViewChild('rdb_StockCategory', { static: true }) rdb_StockCategory: RadioLabelComponent;
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('txti_ECShowSeq', { static: true }) txti_ECShowSeq: ElementRef;

  public kymw5400Model: KYMW5400Model = new KYMW5400Model();

  private selectedPCode = String('');
  private selectedColId = String('');

  private kymw0300InputVO: KYMW0300InputModel = null;		// 商品検索画面のVO
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  /**
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private tableName: Array<any> = null;

  /**
   * カテゴリ商品設定一覧のスタイルを整える配列 CategoryGoodsListRendererから読み替え移植
   */
  public CategoryGoodsListRendererList: Array<any> = [];

  // コンテキストメニュー(右クリック)
  /** コンテキストメニュー(商品一覧) */
  private GoodsContextMenu: Menu;
  /** コンテキストメニュー(カテゴリ商品設定一覧) */
  private ContextMenu: Menu; // コンテキストメニュー(アイコンリスト)

  /**
   *Creates an instance of KYMW5400Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW5400Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private getCategoryCandidacyGoodsInfoService: GetCategoryCandidacyGoodsInfoService,
    private getGoodsCategoryInfoService: GetGoodsCategoryInfoService,
    private get54CategoryInfoService: Get54CategoryInfoService,
    private updateGoodsCategoryInfoService: UpdateGoodsCategoryInfoService,
    public kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);

    this.tableName = [];
    this.tableName['MediumTypeName'] = 'MEDIUM_TYPE';
    this.tableName['ClassCodeName'] = 'CLASS_CODE';
    this.tableName['SmallClassCodeName'] = 'SMALL_CLASS_CODE';
    this.tableName['GoodsName'] = 'GOODS_NAME';
    this.tableName['GoodsStandardName'] = 'GOODS_STANDARD_NAME';
    this.tableName['Pcode'] = 'PCODE';
    this.tableName['ECShowSeq'] = 'EC_SHOW_SEQ';

    // 取扱可能でデータ無しの場合、背景色白、空白表示
    this.CategoryGoodsListRendererList[0] = { labelText: '―', setStyle: '' };
    // 取扱可能でデータ無しの場合、背景色白、空白表示
    this.CategoryGoodsListRendererList[1] = { labelText: '', setStyle: '' };
    // データありの場合：背景色白、●表示
    this.CategoryGoodsListRendererList[2] = { labelText: '●', setStyle: '' };
    // データ登録の場合：背景色青、●表示
    this.CategoryGoodsListRendererList[3] = { labelText: '●', setStyle: getComputedStyle(document.documentElement).getPropertyValue('--bg-blue') };
    // データ削除の場合：背景色ピンク、空白表示
    this.CategoryGoodsListRendererList[4] = { labelText: '　', setStyle: getComputedStyle(document.documentElement).getPropertyValue('--bg-pink') };
  }

  /*--------------------------------------------------------------------------------------------------
    初期処理
  ---------------------------------------------------------------------------------------------------*/

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.kymw5400Model.kymw5400Component = this;
    this.componentName = 'KYMW5400';

    // 受注コード、配達企画回のクリア
    this.kymw5400Model.orderCode = '';						// 受注コード
    this.kymw5400Model.catalogID = '';						// 配達企画回

    setTimeout(() => {
      this.plessEnabledSetting();
    });

    // 初期値設定
    this.kymw5400Model.pageNum = 1;						// ページ番号
    this.kymw5400Model.startDispNum = 0;						// 表示開始件数
    this.kymw5400Model.endDispNum = 0;						// 表示終了件数
    this.kymw5400Model.stockLimitFlg = '0';						// 在庫限定フラグ

    // 商品件数初期化
    this.kymw5400Model.initGoodsCount();

    // グリッドの初期設定(空白行の追加)
    this.categoryGoodsListClear();
    this.goodsListClear();

    // コンテキストメニューの設定
    this.setGoodsContextMenu();
    this.setContextMenu();
  }

  public plessEnabledSetting() {
    // カテゴリ区分ラジオボタンの活性
    // 対象から "商品マスタ" を外すためコメントアウト
    // this.plessEnabled(this.rdb_Category, true);                // 商品マスタラジオボタン
    this.plessEnabled(this.rdb_PlanCategory, true);						// 商品企画マスタラジオボタン
    this.plessEnabled(this.rdb_StockCategory, true);						// 在庫限定ラジオボタン
    // 受注コードの活性
    this.plessEnabled(this.txti_OrderCode, true);						// 受注コード

    // 各ボタンの非活性
    this.plessEnabled(this.btn_Cancel, false);					// 取消ボタン
    this.plessEnabled(this.btn_Update, false);					// 更新ボタン
    this.kymw5400Model.prevDisabled = true;             // 前へボタン
    this.kymw5400Model.nextDisabled = true;             // 次へボタン
    this.plessEnabled(this.btn_Search, false);					// 商品検索ボタン
    this.rdb_PlanCategory.setFocus();
  }

  private setGoodsContextMenu(): void {
    this.GoodsContextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '選択', cmd: 'selectGoods' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.GoodsContextMenu.selectedValue) {
            case 'selectGoods':
              this.eventSelectGoods_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_GoodsList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.GoodsContextMenu !== undefined) {
        // コンテキストメニューの活性非活性制御
        this.eventGoodsListContextMenu_Handler(this.GoodsContextMenu);
        this.GoodsContextMenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode('全生協にコピー', 'none');
  }

  private setContextMenu(): void {
    this.ContextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: '指定', caption: '指定', cmd: 'setCategory' },
          { header: '解除', caption: '解除', cmd: 'unSetCategory' },
          { caption: '-' },

          { header: '全生協に指定', caption: '全生協に指定', cmd: 'setCategoryAll' },
          { header: '全生協を解除', caption: '全生協を解除', cmd: 'unSetCategoryAll' },

        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.ContextMenu.selectedValue) {
            case 'setCategory':
              this.eventSetCategory_CLICKHandler();
              break;
            case 'unSetCategory':
              this.eventUnSetCategory_CLICKHandler();
              break;
            case 'setCategoryAll':
              this.eventSetCategoryAll_CLICKHandler();
              break;
            case 'unSetCategoryAll':
              this.eventUnSetCategoryAll_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_CategoryGoodsList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.ContextMenu !== undefined) {
        // コンテキストメニューの活性非活性制御
        this.eventCategoryGoodsContextMenu_Handler(this.ContextMenu, e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.ContextMenu.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.ContextMenu.itemsSource[1], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode('-', 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.ContextMenu.itemsSource[3], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.ContextMenu.itemsSource[4], 'none');
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (!param.enabled) ? false : true;
      }
    };
  }

  /*--------------------------------------------------------------------------------------------
  /* event area
  /*--------------------------------------------------------------------------------------------*/

  /*--------------------------------------------------------------------------------------------------
    終了イベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 終了ボタン押下イベント
   */
  canDeactivate(): CanDeactivateType {
    const result = new Subject<boolean>();
    // 編集フラグのチェック
    if (this.kymw5400Model.isEdited) { // 編集中の場合
      // 編集内容破棄の確認Msgダイアログ表示
      this.dialogServiceSub.openAlertGetMessage('Q0110', [],
        (closeDetail) => { // OKを押下した場合、画面を閉じる
          if (closeDetail === PlessAlert.Yes) {
            this.kymw5400Model.isEdited = false;
            result.next(true);
          } else {
            result.next(false);
          }
        });
      return result;
    } else { // 未編集の場合
      // 終了処理
      return true;
    }
  }

  /*--------------------------------------------------------------------------------------------------
    取消イベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 取消ボタン押下イベント
   */
  public eventCancel_CLICKHandler(): void {
    // クリア処理
    this.tre_Category.selectedItem = -1;							// カテゴリツリー選択インデックス
    this.categoryGoodsListClear();	// カテゴリ商品設定一覧リスト
    this.kymw5400Model.isEdited = false;						// 編集フラグ
    // 商品件数クリア
    this.kymw5400Model.initGoodsCount();

    // 活性制御(『未編集』に設定する)
    this.enableControl(true);

    // フォーカス設定
    this.tre_Category.focus();
  }

  /*--------------------------------------------------------------------------------------------------
    更新イベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 更新ボタン押下イベント
   *
   * @param event コールバック・イベントへの参照
   */
  public eventUpdate_CLICKHandler(): void {
    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.txti_OrderCode.text)) {
      this.dialogServiceSub.openAlertGetMessage('E0110', ['受注コード']);
      return;
    }

    // 受注コード存在チェック
    if (PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {
      this.dialogServiceSub.openAlertGetMessage('E0122', ['受注コード']);
      return;
    }

    // 受注コード比較
    if (!this.checkOrderCode()) { // 異なる場合
      this.dialogServiceSub.openAlertGetMessage('E0121', ['入力した受注コード', '表示カテゴリの受注コード']);
      return;
    }

    // EC掲載順入力チェック
    if (!this.checkECShowSeqZero(this.kymw5400Model.categoryGoodsList)) {
      this.dialogServiceSub.openAlertGetMessage('E0142', ['入力したEC掲載順', '1'])
      return;
    }

    // EC掲載順重複チェック
    if (!this.checkDuplicationECShowSeq(this.kymw5400Model.categoryGoodsList)) {
      this.dialogServiceSub.openAlertGetMessage('E0115', ['入力したEC掲載順'])
      return;
    }

    // 更新イベント用VO初期化
    const vo = this.kymw5400Model.getUpdateVo();

    // イベントの発行
    this.updateGoodsCategoryInfoService.execute(this.kymw5400Model, vo, null);
  }

  /**
   * 更新完了後処理
   */
  public eventUpdate_COMPLEATEHandler(): void {
    // 活性制御(『未編集』に設定する)
    this.enableControl(true);

    // カテゴリ一覧選択イベント処理
    // カテゴリ商品設定一覧の最新化を行う
    this.eventSelect_CLICKHandler();
  }

  /*--------------------------------------------------------------------------------------------------
    商品マスタイベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 商品マスタラジオボタンがチェックされた時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  // 対象から "商品マスタ" を外すためコメントアウト
  /*public eventchkCategoy_CLICKHandler(): void {
    // 商品マスタラジオボタンの状態チェック
    if (this.rdb_Category.disabled) { // 非活性時
      // カテゴリ関連編集時時（非活性）は処理しない
      return;
    }

    // カテゴリ区分変更後処理
    this.eventCategoryDivChangeMessage_CLOSEHandler();

    // 在庫限定区分を設定
    this.kymw5400Model.stockLimitFlg = '0';
  }*/


  /**
   * 商品企画マスタラジオボタンがチェックされた時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventchkPlanCategoy_CLICKHandler(): void {
    // 商品企画マスタラジオボタンの状態チェック
    if (this.rdb_PlanCategory.disabled) { // 非活性時
      // カテゴリ関連編集時時（非活性）は処理しない
      return;
    }

    // カテゴリ区分変更後処理
    this.eventCategoryDivChangeMessage_CLOSEHandler();

    // 在庫限定区分を設定
    this.kymw5400Model.stockLimitFlg = '0';
  }

  /**
   * 在庫限定ラジオボタンがチェックされた時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventchkStockCategoy_CLICKHandler(): void {
    // 在庫限定ラジオボタンの状態チェック
    if (this.rdb_StockCategory.disabled) { // 非活性時
      // カテゴリ関連編集時時（非活性）は処理しない
      return;
    }

    // カテゴリ区分変更後処理
    this.eventCategoryDivChangeMessage_CLOSEHandler();

    // 在庫限定区分を設定
    this.kymw5400Model.stockLimitFlg = '1';
  }

  /**
   * カテゴリ区分変更後処理
   */
  public eventCategoryDivChangeMessage_CLOSEHandler(): void {
    // 初期化処理
    this.KYMW5400init();

    // 活性制御
    this.plessEnabled(this.txti_OrderCode, true);						// 受注コード
    this.plessEnabled(this.btn_Search, false);					// 商品検索ボタン
  }

  /*--------------------------------------------------------------------------------------------------
    受注コードイベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 「受注コード」変更イベント処理
   *
   *  @event イベント
   */
  public eventOrderCode_CHANGEHandler(event: Event): void {
    // 企画回コードの文字列長チェック
    this.kymw5400Model.catalogID = this.txti_OrderCode.selectedCatalogID;
    // 有効な受注コードが入力されているかのチェック
    if (!PlessViewUtilsSub.isEmpty(this.kymw5400Model.catalogID)) { // ０より大きい場合(有効企画回)
      // 商品検索ボタンを非活性にする
      // 商品検索ボタンは、カテゴリ一覧の表示後に使用可能となる
      this.plessEnabled(this.btn_Search, false);					// 商品検索ボタン
    } else { // ０の場合(無効企画回)
      // 商品検索ボタンを非活性にする
      this.plessEnabled(this.btn_Search, false);					// 商品検索ボタン

      // ページング関連項目初期化
      this.kymw5400Model.prevDisabled = true;             // 前へボタン
      this.kymw5400Model.nextDisabled = true;             // 次へボタン
      this.goodsListClear(); // 商品一覧リスト
      this.kymw5400Model.startDispNum = 0;						// 表示開始件数
      this.kymw5400Model.endDispNum = 0;						// 表示終了件数
      this.kymw5400Model.totalNum = 0;						// 全件数
    }
  }

  /*--------------------------------------------------------------------------------------------------
    表示イベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 表示ボタン押下イベント
   *
   * @param event コールバック・イベントへの参照
   */
  public eventDisplay_CLICKHandler(): void {
    // 編集フラグのチェック
    if (this.kymw5400Model.isEdited) { // 編集中の場合
      // 未処理で復帰
      return;
    } else { // 未編集の場合
      this.eventDisplayMessage_CLOSEHandler();
    }
  }

  /**
   * 表示ボタン押下時の変更破棄確認メッセージ終了後イベント
   */
  public eventDisplayMessage_CLOSEHandler(): void {
    const kymw5400commonVO: KYMW5400commonModel = new KYMW5400commonModel();

    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5400Model.orderCode)) {
      this.dialogServiceSub.openAlertGetMessage('E0110', ['受注コード']);
      return;
    }

    // 受注コード存在チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5400Model.catalogID)) {
      this.dialogServiceSub.openAlertGetMessage('E0122', ['受注コード']);
      return;
    }

    if (this.kymw5400Model.categoryDiv === '2') {
      kymw5400commonVO.stockLimitFlg = '1';
    } else {
      kymw5400commonVO.stockLimitFlg = '0';
    }

    kymw5400commonVO.categoryDiv = this.kymw5400Model.categoryDiv;
    kymw5400commonVO.orderCode = this.kymw5400Model.orderCode;

    // イベントの発行
    this.get54CategoryInfoService.execute(this.kymw5400Model, kymw5400commonVO, null);

    // 編集フラグの初期化(未編集)
    this.kymw5400Model.isEdited = false;
  }

  /*--------------------------------------------------------------------------------------------------
    カテゴリ選択イベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * カテゴリ一覧で選択された時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSelect_CLICKHandler(): void {
    // 編集フラグのチェック
    if (this.kymw5400Model.isEdited) { // 編集中の場合
      // 未処理で復帰
      return;
    } else { // 未編集の場合
      this.eventCategorySelectMessage_CLOSEHandler();
    }
  }

  /**
   * カテゴリ一覧でキーボードで選択された時に呼び出されるメソッド。
   */
  public eventKeybordSelect_KEYDOWNHandler(event: any): void {
    // キーコードのチェック
    if (event.key === 'Enter') { // Enterキーの場合
      // エンターキーの場合はそのカテゴリが選択されたものとして処理する
      this.eventSelect_CLICKHandler();
    }
  }

  /**
   * カテゴリ一覧選択時の変更破棄メッセージ終了後処理
   */
  public eventCategorySelectMessage_CLOSEHandler(): void {
    // 受注コード比較
    if (!this.checkOrderCode()) { // 異なる場合
      this.dialogServiceSub.openAlertGetMessage('E0121', ['入力した受注コード', '表示カテゴリの受注コード']);
      return;
    }

    // 選択されたカテゴリコードからカテゴリ設定商品一覧を表示
    // データ取得条件の設定
    const kymw5400commonVO: KYMW5400commonModel = new KYMW5400commonModel();
    kymw5400commonVO.categoryDiv = this.kymw5400Model.categoryDiv;
    kymw5400commonVO.orderCode = this.txti_OrderCode.text;

    // 選択カテゴリ取得
    const selectedItem: any = this.tre_Category.selectedItem;

    // カテゴリ関連情報表示イベント用VO初期化
    kymw5400commonVO.categoryCode = selectedItem.CategoryCode;		// カテゴリコード

    // イベントの発行
    this.getGoodsCategoryInfoService.execute(this.kymw5400Model, kymw5400commonVO, null);
  }

  /*--------------------------------------------------------------------------------------------------
    商品一覧イベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 右クリックメニューが表示されたときに呼び出されるメソッド
   * 主に右クリックされた行の選択と、メニュー項目の表示設定を行う
   *
   * @param event:コンテキストイベント
   */
  public eventGoodsListContextMenu_Handler(contextMenu: Menu): void {
    contextMenu.itemsSource.forEach(item => {
      item.enabled = false;
      // メニュー項目の表示設定
      // 商品一覧とカテゴリの両方が選択されているときのみ活性にする
      if (this.dtg_GoodsList.selection.row >= 0 &&						// 商品一覧で選択あり、かつ
        this.tre_Category.selectedItem) {						// カテゴリ一覧で選択ありの場合

        // 活性フラグの初期化(活性) // コンテキストメニューの活性制御
        item.enabled = true;
      }
    });
  }

  /*--------------------------------------------------------------------------------------------------
    商品一覧コンテキストメニューイベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 商品一覧コンテキストメニュー「選択」クリックイベント
   */
  public eventSelectGoods_CLICKHandler(): void {
    // カテゴリ商品設定一覧の退避
    let bkList: Array<any> = this.kymw5400Model.categoryGoodsList;	// カテゴリ商品設定一覧バックアップ

    // カテゴリ商品設定一覧追加処理
    for (let i = Number(0); i < this.dtg_GoodsList.selectedItems.length; i++) { // 商品一覧での選択行数分ループ
      // カテゴリ商品設定一覧追加処理
      if (!this.kymw5400Model.addCategoryGoodsItem(this.dtg_GoodsList.selectedItems[i])) { // 同一商品設定済の場合
        // 同一商品が選択済みの場合、カテゴリ商品設定一覧を元に戻し、メッセージを表示する
        this.kymw5400Model.categoryGoodsList = bkList;
        this.dialogServiceSub.openAlertGetMessage('E0134', ['同一商品情報']);
        return;
      }
    }

    // カテゴリ商品設定一覧バックアップの開放
    bkList = null;
  }

  /*--------------------------------------------------------------------------------------------------
    商品検索イベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 「商品検索」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventSearchGoods_CLICKHandler(): void {
    // 「商品検索ポップアップ用インプットVO」の生成
    // ２回目以降の表示は前回の情報を引き継ぐ
    if (this.kymw0300InputVO === null) {
      this.kymw0300InputVO = new KYMW0300InputModel();
    }
    // 企画関連条件を表示する（企画検索フラグ:1）
    this.kymw0300InputVO.catalogSearchFlg = 1;

    // 商品検索画面(モーダル)を表示する。
    const componentRef = this.dialogServiceSub.openModal(KYMW0300Component);
    const instance = componentRef.componentInstance as KYMW0300Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0300InputVO);
    instance.setKYMW0300Parameter = (kymw0300OutputVO: KYMW0300OutputModel) => {
      this.setKYMW0300Parameter(kymw0300OutputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();

      // 全件数が当該ページ最終行番号より大きい場合
      if (this.kymw5400Model.totalNum > this.kymw5400Model.endDispNum) {
        document.getElementById('btnNext').tabIndex = 0;
      } else {
        document.getElementById('btnNext').tabIndex = -1;
      }
      // 当該ページ先頭行番号が１より大きい場合
      if (this.kymw5400Model.startDispNum > 1) {
        document.getElementById('btnPrev').tabIndex = 0;
      } else {
        document.getElementById('btnPrev').tabIndex = -1;
      }
    };
  }

  /**
   * 商品検索サブ画面の結果設定
   * 商品検索サブ画面で設定した条件をもとに候補リストを表示
   */
  public setKYMW0300Parameter(outputVO: KYMW0300OutputModel): void {
    // 前回の検索条件を保持
    this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);

    // ページング関連項目初期化
    this.kymw5400Model.pageNum = 1;
    this.kymw5400Model.startDispNum = 0;
    this.kymw5400Model.endDispNum = 0;
    this.kymw5400Model.totalNum = 0;
    this.kymw5400Model.sortKey = '';
    this.kymw5400Model.sortOrder = '';

    DataGridUtil.clearHeaderText(this.dtg_GoodsList);


    // 各ボタンの非活性
    this.kymw5400Model.prevDisabled = true;             // 前へボタン
    this.kymw5400Model.nextDisabled = true;             // 次へボタン

    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw5400Model.getGetCWSPlanGoodsSearchVO(this.kymw0300InputVO);
    this.getCategoryCandidacyGoodsInfoService.execute(this.kymw5400Model, vo, null);
  }

  /*--------------------------------------------------------------------------------------------------
    商品一覧ページ制御イベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 「前へ」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventPrev_CLICKHandler(): void {
    // ページ番号をディクリメント(-1)
    this.kymw5400Model.pageNum = this.kymw5400Model.pageNum - 1;

    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw5400Model.getGetCWSPlanGoodsSearchVO(this.kymw0300InputVO);
    this.getCategoryCandidacyGoodsInfoService.execute(this.kymw5400Model, vo, null);
  }

  /**
   * 「次へ」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventNext_CLICKHandler(): void {
    // ページ番号をインクリメント(+1)
    this.kymw5400Model.pageNum = this.kymw5400Model.pageNum + 1;

    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw5400Model.getGetCWSPlanGoodsSearchVO(this.kymw0300InputVO);
    this.getCategoryCandidacyGoodsInfoService.execute(this.kymw5400Model, vo, null);
  }

  /**
   * 商品一覧データグリッド ヘッダクリックイベント処理
   */
  public eventDtgPlanGoodsList_HEADERRELEASEHandler(e: MouseEvent, grid: FlexGrid): void {
    // 後続のデフォルトイベントをキャンセル
    event.preventDefault();

    // データが0件の場合は何もしない

    // if (this.dtg_GoodsList.selectionMode === 0) { return; }
    if (!DataGridUtil.isSortable(e, grid)) {
      return;
    }

    // クリックされたデータグリッドの列から、DBの物理項目を取得
    this.kymw5400Model.sortKey = this.tableName[this.dtg_GoodsList.columns[grid.hitTest(e).col].binding];

    // 取得できなかったら何もしない
    if (!this.kymw5400Model.sortKey) {
      return;
    }
    // データグリッドのヘッダテキストを描画し、ASCとDESCをVOに設定
    this.kymw5400Model.sortOrder = DataGridUtil.switchHeaderText(e, grid);

    // ページカウンタの初期化
    this.kymw5400Model.pageNum = 1;

    // モデルのメソッドを使ってVOをサービスに渡し、サーバー通信を行う
    this.getCategoryCandidacyGoodsInfoService.execute(this.kymw5400Model,
      this.kymw5400Model.getGetCWSPlanGoodsSearchVO(this.kymw0300InputVO));
  }

  /**
   * 右クリックメニューが表示されたときに呼び出されるメソッド
   * 主に右クリックされた行の選択と、メニュー項目の表示設定を行う
   *
   * @param event:コンテキストイベント
   */
  public eventCategoryGoodsContextMenu_Handler(contextMenu: Menu, e: MouseEvent): void {
    // 右クリックされたチェックボックスのＰコードと列の情報を保持
    const red: any = this.dtg_CategoryGoodsList.hitTest(e);
    if (red.row === -1) {
      return;
    }

    this.selectedPCode = this.dtg_CategoryGoodsList.getCellData(red.row, 2, true);
    this.selectedColId = this.dtg_CategoryGoodsList.columns[red.col].binding;

    const selectedItems = this.dtg_CategoryGoodsList.selectedItems;

    if (!this.selectedPCode || PlessViewUtilsSub.isEmptyArray(selectedItems)) {
      return;
    } // PCodeが取れない場合何もしない

    contextMenu.itemsSource.forEach(item => {
      item.enabled = true;
      if (selectedItems[0][this.selectedColId] === '0') {
        item.enabled = false;
      }

      if (this.kymw5400Model.categoryDiv === '0') {
        if (item.caption.caption === '指定' || item.caption.caption === '解除') {
          // 商品カテゴリの場合、「設定」「解除」は使用不可（全生協用のみ使用可）
          item.enabled = false;
        }
      }

      if (this.getFuncPermission('KYMW5400') !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
        item.enabled = false;
      }
    });

    if (red.col >= 6) {
      // いとぐちさとうなにのカラムで、PCodeが取得できた場合(上部のreturnで弾いてる)コンテキストメニューを表示する
      this.ContextMenu.show(e);
    }
  }

  /**
   * カテゴリ関連一覧「EC掲載順」編集イベント
   */
  public eventECShowSeq_CHANGEHandler(): void {
    // 活性制御(『編集中』に設定する)
    this.enableControl(false);

    // EC掲載順を編集済み
    this.dtg_CategoryGoodsList.selectedItems[0].isEditedECShowSeq = true;
  }

  /**
   * カテゴリ関連一覧「指定」クリックイベント
   */
  public eventSetCategory_CLICKHandler(): void {
    // 活性制御(『編集中』に設定する)
    this.enableControl(false);

    // 生協解除処理
    this.kymw5400Model.setCoopFlg(this.selectedPCode, this.selectedColId);
  }

  /**
   * カテゴリ関連一覧「解除」クリックイベント
   */
  public eventUnSetCategory_CLICKHandler(): void {
    // 活性制御(『編集中』に設定する)
    this.enableControl(false);

    // 生協解除処理
    this.kymw5400Model.unsetCoopFlg(this.selectedPCode, this.selectedColId);
  }

  /**
   * カテゴリ関連一覧「全生協に指定」クリックイベント
   */
  public eventSetCategoryAll_CLICKHandler(): void {
    // 活性制御(『編集中』に設定する)
    this.enableControl(false);

    // 全生協設定処理
    this.kymw5400Model.setCoopFlgAll(this.selectedPCode, this.selectedColId);
  }

  /**
   * カテゴリ関連一覧「全生協を解除」クリックイベント
   */
  public eventUnSetCategoryAll_CLICKHandler(): void {
    // 活性制御(『編集中』に設定する)
    this.enableControl(false);

    // 全生協解除処理
    this.kymw5400Model.unsetCoopFlgAll(this.selectedPCode, this.selectedColId);
  }

  /*--------------------------------------------------------------------------------------------------
    「CWS企画商品別カテゴリ設定一覧表」ボタンイベント
  ---------------------------------------------------------------------------------------------------*/
  /**
    * 「EC企画商品別カテゴリ設定一覧表」ボタン押下イベント処理
    *
    *  @event イベント
    */
  public eventKYMW58_CLICKHandler(): void {
    const componentRef = this.dialogServiceSub.openModal(KYMW5800Component);
    const instance = componentRef.componentInstance as KYMW5800Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }
  /*--------------------------------------------------------------------------------------------------
    Util Area
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 初期化処理
   */
  private KYMW5400init(): void {
    // データ初期化
    if (!this.kymw5400Model.orderCode) {
      this.kymw5400Model.orderCode = ''; // 受注コード
    }
    if (!this.kymw5400Model.catalogID) {
      this.kymw5400Model.catalogID = ''; // 企画回コード
    }
    this.categoryGoodsListClear(); // カテゴリ商品設定一覧
    this.goodsListClear(); // 商品一覧
    this.kymw5400Model.isEdited = false;							// 編集フラグ(未編集)
    // 商品件数初期化
    this.kymw5400Model.initGoodsCount();

    // カテゴリ一覧(ツリー)クリア
    this.kymw5400Model.clean();

    // ページング関連項目初期化
    this.kymw5400Model.pageNum = 1;
    this.kymw5400Model.startDispNum = 0;
    this.kymw5400Model.endDispNum = 0;
    this.kymw5400Model.totalNum = 0;
    this.kymw5400Model.sortKey = '';
    this.kymw5400Model.sortOrder = '';

    DataGridUtil.clearHeaderText(this.dtg_GoodsList);

    // 活性制御
    this.plessEnabled(this.btn_Cancel, false);						// 取消ボタン
    this.plessEnabled(this.btn_Update, false);						// 更新ボタン
    this.kymw5400Model.prevDisabled = true;             // 前へボタン
    this.kymw5400Model.nextDisabled = true;             // 次へボタン
  }

  /**
   * 活性制御
   */
  public enableControl(enableMode: boolean): void {
    // 活性制御
    // 対象から "商品マスタ" を外すためコメントアウト
    //this.plessEnabled(this.rdb_Category, enableMode);				// 商品マスタラジオボタン
    this.plessEnabled(this.rdb_PlanCategory, enableMode);		// 商品企画マスタラジオボタン
    this.plessEnabled(this.rdb_StockCategory, enableMode);	// 在庫限定ラジオボタン

    // 活性制御
    this.plessEnabled(this.txti_OrderCode, enableMode);			// 受注コード

    // 活性制御
    this.plessEnabled(this.btn_Display, enableMode);				// 表示ボタン
    this.tre_Category.isDisabled = !enableMode; // カテゴリ一覧
    this.plessEnabled(this.btn_Cancel, !enableMode);				// 取消ボタン
    this.plessEnabled(this.btn_Update, !enableMode);				// 更新ボタン
    this.kymw5400Model.isEdited = !enableMode;				// 編集フラグ
  }

  /**
   * 受注コード比較
   * テキストインプットフィールドに表示されている受注コードとカテゴリ一覧表示中の受注コードが
   * 一致しているか否かを判定し、判定結果を返却する。
   */
  public checkOrderCode(): boolean {
    // テキストインプットフィールドに表示されている受注コードとカテゴリ一覧表示に使用した受注コードの比較
    if (this.kymw5400Model.treeOrderCode === this.kymw5400Model.orderCode) { // 同一受注コードの場合
      // 判定結果(一致)を返却
      return true;
    } else { // 異なる場合
      // 判定結果(不一致)を返却
      return false;
    }
  }

  /**
   * EC掲載順の0以下の入力チェックする
   *
   * @param targetArray  チェック対象
   * @return true:0以下なし false:0以下あり
   */
  public checkECShowSeqZero(targetArray: Array<any>): boolean {
    for (let i = Number(0); i < targetArray.length; i++) {
      if (parseInt(targetArray[i].ECShowSeq) === 0) {
        return false;
      }
    }
    return true;
  }

  /**
   * EC掲載順の重複をチェックする
   *
   * @param targetArray  チェック対象
   * @return true:重複なし false:重複あり
   */
  public checkDuplicationECShowSeq(targetArray: Array<any>): boolean {
    const existList = [];
    for (let i = Number(0); i < targetArray.length; i++) {
      if (!PlessViewUtilsSub.isEmpty(targetArray[i].ECShowSeq)) {
        const seq = parseInt(targetArray[i].ECShowSeq);
        if (existList.includes(seq)) {
          return false;
        } else {
          existList.push(seq);
        }
      }      
    }
    return true;
  }

  /**
   * ツリーの再ロード
   */
  public updateTreeView() {
    // ツリーのロード
    this.tre_Category.loadTree();
  }

  /**
   * カテゴリ商品設定一覧のクリア処理
   *
   * @private
   * @memberof KYMW5400Component
   */
  public categoryGoodsListClear(): void {
    this.kymw5400Model.categoryGoodsList = [];
  }

  /**
   * 商品一覧のクリア処理
   *
   * @private
   * @memberof KYMW5400Component
   */
  public goodsListClear(): void {
    this.kymw5400Model.goodsList = [];
  }

  /**
   * データ入れ替え時、カテゴリ商品設定一覧の選択を解除する
   *
   * @memberof KYMW5400Component
   */
  onItemsSourceChangedCategoryGoodsList(): void {
    this.dtg_CategoryGoodsList.select(-1, -1);
  }

  /**
   * データ入れ替え時、商品一覧の選択を解除する。
   *
   * @memberof KYMW5400Component
   */
  onItemsSourceChangedGoodsList(): void {
    this.dtg_GoodsList.select(-1, -1);
  }

  /**
   * ツリー内のデザインを整えるクラス CategoryTreeRendererから移植
   *
   * @param {TreeView} treeView
   * @param {FormatNodeEventArgs} e
   * @memberof KYMW5400Component
   */
  formatItem(treeView: TreeView, e: FormatNodeEventArgs) {
    // タイムセールカテゴリは赤字で表示する
    if (e.dataItem.TimeSaleFlg === '1') {
      e.element.innerHTML =
        `<span class="time_sale_category">${e.dataItem.CategoryName}</span>`;
    }
  }

  /**
   * フォーカス制御
   *
   * @param rowIndex  行
   * @param colIndex  列
   * @memberof KYMW5400Component
   */
  onInputFocus(rowIndex: number, colIndex: number) {
    this.dtg_CategoryGoodsList.select(rowIndex, colIndex);
  }
}
